import { observer } from "mobx-react";
import { useContext, useEffect, useState } from "react";

import { LoginFormComponent } from "@kimoycatayas/pe-ui-kit-test";

import { PageContainer } from "../components/page";

import { UserStore } from "..";
import apiClient from "../api/pe-api-client";
import { UserType } from "../state/UserState";
import { useNavigate } from "react-router";
import { PEProgressBar } from "../components/linear-progress";
import { useColors } from "../provider/colors-provider";
import { useVendor } from "../provider/vendor-provider";

const LoginPage = observer(() => {
  const { getVendorTitle, getVendorSubtitle, getVendorLogo } = useVendor();
  const { primary } = useColors();
  const userStore = useContext(UserStore);
  const navigate = useNavigate();

  const [loginInProgress, setLoginInProgress] = useState(false);

  const handleSubmit = (email: string, password: string) => {
    setLoginInProgress(true);

    apiClient
      .userLogin(email, password)
      .then((response: any) => {
        let user: UserType = {
          userId: response.data.userIdInt,
          userName: response.data.userId,
          firstName: response.data.firstName,
          lastName: response.data.firstLast,
        };
        userStore.login(user, response.data.commandCentreVenues);
        setLoginInProgress(false);
        navigate("/select-venue");
      })
      .catch((error) => {
        console.log(error);
        setLoginInProgress(false);
      });
  };

  const {
    selectedVenue,
    isLoggedIn,
    userVenues,
    userVenuesAlphabetical,
    venueSearchTerm,
  } = userStore;

  useEffect(() => {
    if (selectedVenue && isLoggedIn) {
      navigate("/home");
    }

    if (isLoggedIn) {
      navigate("/select-venue");
    }
  }, []);

  if (loginInProgress) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <PEProgressBar />
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <LoginFormComponent
        handleSubmit={handleSubmit}
        title={getVendorTitle()}
        subtitle={getVendorSubtitle()}
        color="white"
        backgroundColor={primary}
        imageUrl={getVendorLogo()}
      />
    );
  }

  if (isLoggedIn && userVenuesAlphabetical?.length === 0) {
    return (
      <PageContainer>
        {userVenuesAlphabetical?.length === 0 && (
          <div css={{ textAlign: "center", fontSize: 16, marginBottom: 4 }}>
            No Venues found
          </div>
        )}
      </PageContainer>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <PEProgressBar />
    </div>
  );
});

export default LoginPage;
